module.exports = __webpack_public_path__ + "static/media/tombstone-alt.96f6cac5.svg";